import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export class ReadOnlyKeycloak {
  constructor(keycloakToken, tokenParsed) {
    _defineProperty(this, "token", void 0);

    _defineProperty(this, "tokenParsed", void 0);

    _defineProperty(this, "logout", () => ({}));

    _defineProperty(this, "onAuthRefreshSuccess", () => ({}));

    this.token = keycloakToken;
    this.tokenParsed = tokenParsed;
  }

}
export const getLdapDn = tokenParsed => (tokenParsed === null || tokenParsed === void 0 ? void 0 : tokenParsed.ldapDN) || (tokenParsed === null || tokenParsed === void 0 ? void 0 : tokenParsed.ldapDn) || '';
export const getAgency = ldapDn => ldapDn && ldapDn.split(',ou=')[2];
/**
 * Resolve agency for API calls.
 * Order: props agency → URL ?agency= → localStorage 'agency-support'
 * (cert-app) → keycloak LDAP. Guards for non-browser (Node) runtimes.
 */

export const resolveAgency = (agency, keycloak) => {
  if (agency) {
    return agency;
  }

  if (typeof window !== 'undefined') {
    const fromQuery = new URLSearchParams(window.location.search).get('agency');

    if (fromQuery) {
      return fromQuery;
    }

    try {
      var _window$localStorage;

      const fromStorage = (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem('agency-support');

      if (fromStorage) {
        return fromStorage;
      }
    } catch {// localStorage can throw (privacy mode / disabled); fall through to token
    }
  }

  if (keycloak) {
    const tokenParsed = 'idTokenParsed' in keycloak && keycloak.idTokenParsed || keycloak.tokenParsed;
    return getAgency(getLdapDn(tokenParsed)) || undefined;
  }

  return undefined;
};
export const isMummsAdmin = tokenParsed => {
  var _tokenParsed$realm_ac;

  return tokenParsed && ((_tokenParsed$realm_ac = tokenParsed.realm_access) === null || _tokenParsed$realm_ac === void 0 ? void 0 : _tokenParsed$realm_ac.roles.includes('admin'));
};
export const validateAgency = (tokenParsed, agency) => getAgency(getLdapDn(tokenParsed)) === agency || isMummsAdmin(tokenParsed);
export const getHbcLocation = (siteId, siteList) => {
  const currentSite = siteList.length ? siteList.find(({
    id
  }) => id === siteId) : null;
  return currentSite ? currentSite.hbcLocation : null;
};
export const isUserImpersonating = currentUser => {
  const {
    mummsProfile,
    lastName,
    email
  } = currentUser;
  return !!mummsProfile || lastName.split('_')[1] === 'im' && email.split('@')[1] === 'mumms.com';
};
export const isMummsUser = currentUser => {
  const {
    email
  } = currentUser;
  return email.split('@')[1] === 'mumms.com';
};